module.exports = __webpack_public_path__ + "static/img/11.a4f5b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/11.png
// module id = hI9p
// module chunks = 0